var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1110.082px",
    height: "1000px",
    viewBox: "0 0 1110.082 1000",
    enableBackground: "new 0 0 1110.082 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#73CBEA",
    d: "M776.482,457.497c-3.782-30.888-13.857-59.81-28.927-85.462L555.039,0L362.516,372.035h0.014 c-15.081,25.652-25.142,54.575-28.922,85.462v0.013c-0.519,4.238-0.937,8.52-1.225,12.838c-0.013,0.333-0.039,0.681-0.071,1.023 c-0.271,4.468-0.434,8.946-0.434,13.479c0,123.26,99.909,223.176,223.162,223.176c123.25,0,223.165-99.916,223.165-223.176 c0-4.532-0.168-9.01-0.453-13.479c-0.025-0.343-0.052-0.689-0.077-1.023c-0.279-4.318-0.687-8.6-1.19-12.838v-0.013H776.482z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#73CBEA",
    d: "M281.168,740.459c6.106-4.111,7.742-12.438,3.601-18.539c-4.131-6.112-12.407-7.738-18.533-3.633 c-26.688,18.009-40.232,38.186-40.232,59.981c0,78.936,169.523,121.519,329.048,121.519c159.513,0,329.013-42.583,329.013-121.519 c0-20.112-11.656-38.97-34.645-56.02c-5.905-4.384-14.278-3.14-18.675,2.778c-4.403,5.925-3.153,14.284,2.784,18.662 c10.892,8.095,23.861,20.638,23.861,34.578c0,44.861-124.166,94.819-302.313,94.819c-178.185,0-302.346-49.958-302.346-94.819 C252.732,762.857,268.195,749.194,281.168,740.459"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#73CBEA",
    d: "M974.94,669.379c-6.839-2.778-14.597,0.505-17.419,7.298c-2.784,6.831,0.479,14.615,7.316,17.399 c76.448,31.218,118.525,69.177,118.525,106.922c0,83.195-212.296,172.271-528.318,172.271 c-316.042,0-528.345-89.075-528.345-172.271c0-38.943,44.69-77.887,125.837-109.635c6.874-2.701,10.26-10.445,7.589-17.322 c-2.704-6.883-10.493-10.244-17.309-7.55C49.362,703.07,0,749.59,0,801.023C0,912.614,243.773,1000,555.046,1000 c311.25,0,555.036-87.386,555.036-198.977C1110.107,750.981,1063.375,705.447,974.94,669.379"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.0b64e72187e696af4e6640051c5bad23.svg";
export { ForwardRef as ReactComponent };